import React from 'react';
import { RootState } from 'src/common';
import { useCoreSelector } from 'src/redux';

interface IProps1 {
  experiment: string;
  variant: string;
  default?: never;
  children: JSX.Element;
}
interface IProps2 {
  experiment: string;
  variant?: never;
  default: boolean;
  children: JSX.Element;
}

type IProps = IProps1 | IProps2;

export function ABTest(props: IProps) {
  const ABTestData = useCoreSelector(
    (state: RootState) => state.common.AbTestExperiments
  );

  if (!ABTestData || !ABTestData?.[props.experiment]) {
    if (props.default) return props.children;
    return <></>;
  }
  if (ABTestData[props.experiment] !== props.variant) return <></>;
  return props.children;
}

export default ABTest;
